module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/slider-input/slider-input.component.scss
// module id = ./src/app/modules/common-module/components/slider-input/slider-input.component.scss
// module chunks = 9